// INSPECTION STATUS
export const GET_INSPECTION_STATUSES = '/inspection-status/query';
